
import React from 'react';

interface DarkOverlayProps {
  darkOverlayOpacity: number;
}

const DarkOverlay = ({ darkOverlayOpacity }: DarkOverlayProps) => {
  return (
    <>
      {/* Dark gradient overlay that appears on scroll */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-gray-900 via-black to-black"
        style={{ opacity: darkOverlayOpacity }}
      />

      {/* Final dark gradient at the very bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black via-black/90 to-transparent z-5" />
      
      {/* Particles and animated effects removed for performance */}
    </>
  );
};

export default DarkOverlay;
